import { WbCronExpressionInput } from '@agilelab/plugin-wb-platform';
import { useCallback, useMemo } from 'react';
import { isHidden } from '../../utils';
import { UseDependencyManagerResult } from '../../MultiStepJsonForm/DependencyManager';
import { extractFieldPathFromRjsfId } from '../../MultiStepJsonForm/utils/extractFieldPathFromRjsfId';

export const CronExpressionPicker = (props: any) => {
  const { formData, onChange, uiSchema, schema, idSchema, formContext } = props;

  // Extract dependency manager and field path
  const dependencyManager = formContext?.dependencyManager as
    | UseDependencyManagerResult
    | undefined;
  const fieldPath = useMemo(() => {
    const id = idSchema?.$id || '';
    return extractFieldPathFromRjsfId(id);
  }, [idSchema]);

  // Handle changes with dependency manager support
  const handleChange = useCallback(
    (value: string) => {
      // Notify dependency manager to propagate changes to dependents, or fallback to onChange
      if (dependencyManager?.notifyUpdate && fieldPath) {
        dependencyManager.notifyUpdate({
          fieldPath,
          value,
          source: 'user',
          intent: 'manual',
        });
      } else {
        onChange(value);
      }
    },
    [onChange, dependencyManager, fieldPath],
  );

  return (
    <WbCronExpressionInput
      value={formData}
      onChange={handleChange}
      title={schema.title}
      description={schema.description}
      isHidden={isHidden(uiSchema)}
    />
  );
};
